import * as types from '../constants/actionTypes';
import * as project from '../models/project';

function projectsAction(request) {
  return {
    type: types.PROJECTS,
    payload: request,
  };
}

export function fetchProjects() {
  return projectsAction(project.getPortfolio());
}



// WEBPACK FOOTER //
// ./src/actions/projectsActions.js